import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

// A phone screen showing a QR is small, glossy and often out of focus, so ask the camera for a
// high resolution stream, look only for QR codes, and use the browser's native barcode detector
// when it exists — it reads far more reliably than the JS fallback.
const CAMERA = { facingMode: "environment" };

const CONFIG = {
  fps: 15,
  // Percentage of the viewfinder, so the box always fits whatever resolution we are given.
  qrbox: (w, h) => {
    const edge = Math.floor(Math.min(w, h) * 0.8);
    return { width: edge, height: edge };
  },
  aspectRatio: 1,
  disableFlip: false,
  videoConstraints: {
    facingMode: "environment",
    width: { ideal: 1920 },
    height: { ideal: 1080 },
  },
};

/** Starts a QR camera scan in `elementId`. Resolves with the scanner, or throws. */
export const startQrScanner = async (elementId, onDecode) => {
  const scanner = new Html5Qrcode(elementId, {
    verbose: false,
    formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
    experimentalFeatures: { useBarCodeDetectorIfSupported: true },
  });
  try {
    await scanner.start(CAMERA, CONFIG, (text) => onDecode(text));
  } catch (e) {
    // Some tablets reject the requested resolution — retry with whatever the camera offers.
    console.warn("QR scanner: high-res start failed, retrying with defaults", e);
    const { videoConstraints, ...basic } = CONFIG;
    await scanner.start(CAMERA, basic, (text) => onDecode(text));
  }
  return scanner;
};

export const stopQrScanner = async (scanner) => {
  try {
    await scanner?.stop();
    scanner?.clear();
  } catch {}
};
